/**
 * Base environment configuration for Forms app.
 * All environment files should spread this object.
 */
export const environmentBase = {
  appName: 'Forms',
  appSubtitle: 'Create and manage request entry points',
  registerInterestUrl: '',
  contactEmail: '',
  /**
   * reCAPTCHA v3 site key for public short URL forms. Must match RECAPTCHA_SECRET_KEY on Functions.
   */
  recaptchaSiteKey: '6Le1dbEsAAAAAFNB3-2_zjP_HhXd18GPt3gZ8eca',
  /**
   * Public Forms origin for printed ticket QR order-follow links (no trailing slash).
   * Match `functions/src/config/public_urls.py` / QR `shortUrl` host (default https://forms.crowdctrl.app).
   */
  formsPublicBaseUrl: 'https://forms.crowdctrl.app',
};
